const PricingTabs = ({
  activeTab,
  setActiveTab,
  pricingDurationActive,
  setPricingDurationActive,
  disableDeveloperAPI,
}) => {
  return (
    <div className="pricing-tabs">
      <div className="pricing-tabs-categories">
        <div
          className={`pricing-tab-category${activeTab === 1 ? ' active' : ''}`}
          onClick={() => setActiveTab(1)}>
          <p>Content Owners</p>
        </div>
        {!disableDeveloperAPI && (
          <div
            className={`pricing-tab-category${
              activeTab === 2 ? ' active' : ''
            }`}
            onClick={() => setActiveTab(2)}>
            <p>Developer API</p>
          </div>
        )}
        <div
          className={`pricing-tab-category${activeTab === 3 ? ' active' : ''}`}
          onClick={() => setActiveTab(3)}>
          <p>Legal Professionals</p>
        </div>
      </div>
      <div className="pricing-tabs-duration">
        <div className="pricing-duration-toggle">
          <div className="pricing-duration-toggle__container">
            <div
              onClick={() => setPricingDurationActive(1)}
              className={`pricing-duration-switch left${
                pricingDurationActive === 1 ? ' active' : ''
              }`}>
              <span>Annual</span>
              <span className="pricing-duration-switch__label">
                Save up to 44%
              </span>
            </div>
            <div
              onClick={() => setPricingDurationActive(2)}
              className={`pricing-duration-switch right${
                pricingDurationActive === 2 ? ' active' : ''
              }`}>
              <span>Monthly</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingTabs
